import {Platform} from 'react-native';

import MetaAnalyticsLogger from './MetaAnalyticsLogger';
import {MetaAnalyticsEvent} from './types';

export const MetaAnalytics: MetaAnalyticsLogger = {
  logStandardEvent: async (event: MetaAnalyticsEvent) =>
    Platform.OS === 'web' &&
    window.fbq('track', event.eventName, event.parameters),

  logCustomEvent: async (event: MetaAnalyticsEvent) =>
    Platform.OS === 'web' &&
    window.fbq('trackCustom', event.eventName, event.parameters),
};
